import api from "./api";
import { APIs } from "../constants/APIConstants";
import { GLOBAL_MEETING_DATA } from "../constants/PublicVariables";

export default class BookmarkAPI {
    getBookmarks() {
        return api.get(APIs.ADD_BOOKMARKS.replace("{SessionId}", GLOBAL_MEETING_DATA.sessionId));
    }

    addBookmarks(req) {
        return api.post(APIs.ADD_BOOKMARKS.replace("{SessionId}", GLOBAL_MEETING_DATA.sessionId), req);
    }

    tagBookmarks(req) {
        return api.postStorage(APIs.TAG_BOOKMARKS, req);
    }
}
